import { render, staticRenderFns } from "./ViewAsLogout.vue?vue&type=template&id=1a221ac0&"
import script from "./ViewAsLogout.vue?vue&type=script&lang=js&"
export * from "./ViewAsLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports